var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStudiesSideMenuIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  viewBox: "0 0 16 17",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeWidth: 1.5,
  d: "M14.333 8.5V12c0 1.886 0 2.828-.585 3.414-.586.586-1.529.586-3.415.586h-7.25a2.083 2.083 0 0 1 0-4.167h7.25c1.886 0 2.829 0 3.415-.585.585-.586.585-1.529.585-3.415V5c0-1.886 0-2.828-.585-3.414C13.162 1 12.219 1 10.333 1H5c-1.886 0-2.828 0-3.414.586S1 3.114 1 5v8.917"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "m5.167 6.834.96.96a1 1 0 0 0 1.414 0l2.626-2.627"
})));
export { SvgStudiesSideMenuIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/studies-side-menu-icon.svg";